export default [
    {
        name: '__slot:zen_report_publication_title',
        sortField: 'title',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'datePublishAt',
        sortField: 'datePublishAt',
        type: 'dateRange',
        useInFilter: false,
        callback: 'zenDatePublishAt',
    },
    {
        name: 'channelTitle',
        sortField: 'channelTitle',
        type: 'string',
        useInFilter: true,
        callback: 'zenLinkChannel',
    },
    {
        name: 'typeLabel',
        sortField: 'type',
        type: 'zenPublicationsTypes',
        defaultValue: () => [],
        useInFilter: true,
    },
    {
        name: 'countViews',
        sortField: 'countViews',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
    },
    {
        name: 'countViewsTillEnd',
        sortField: 'countViewsTillEnd',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
    },
    {
        name: 'countLikes',
        sortField: 'countLikes',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
    },
    {
        name: 'countComments',
        sortField: 'countComments',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
        callback: 'zenCommentWrap',
    },
]
